import {
  EndOfJourneyTemplate,
  EndOfJourneyTemplateBasic
} from '../../lib/types/models/end-of-journey-template/end-of-journey-template'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type EndOfJourneyTemplateMap = {
  ID_ONLY: EndOfJourneyTemplateBasic
  BASIC: EndOfJourneyTemplateBasic
  LIGHT: EndOfJourneyTemplate
  PARTIAL: EndOfJourneyTemplate
  FULL: EndOfJourneyTemplate
}

export function getEndOfJourneyTemplate(id: number): Promise<EndOfJourneyTemplate>

export function getEndOfJourneyTemplate<T extends keyof EndOfJourneyTemplateMap>(
  id: number,
  version: T
): Promise<EndOfJourneyTemplateMap[T]>

export function getEndOfJourneyTemplate<T extends keyof EndOfJourneyTemplateMap>(
  id: number,
  version?: T
) {
  return restApiClient
    .url(
      encodeNestedObject(constructApiUrl(API['end-of-journey-templates'].get.url, { id }), {
        version
      })
    )
    .get<
      T extends keyof EndOfJourneyTemplateMap ? EndOfJourneyTemplateMap[T] : EndOfJourneyTemplate
    >()
}
